import { gql } from "@apollo/client";

const PRICING_BUNDLE_FIELDS = gql`
  fragment PricingBundleFields on PricingBundle {
    id
    name
    type
    isWeText
    isSingleUse
    description
    prices {
      id
      priceInMillicents
      sku {
        id
        name
        description
      }
    }
  }
`;

const TENANT_ASSIGNMENT_FIELDS = gql`
  ${PRICING_BUNDLE_FIELDS}
  fragment TenantAssignmentFields on TenantPricingBundleAssignment {
    id
    effectiveDate
    expirationDate
    reasonCode
    notes
    createdBy {
      email
      fullName
    }
    pricingBundle {
      ...PricingBundleFields
    }
  }
`;

const SUBACCOUNT_ASSIGNMENT_FIELDS = gql`
  ${PRICING_BUNDLE_FIELDS}
  fragment SubaccountAssignmentFields on SubaccountPricingBundleAssignment {
    id
    subaccountId
    subaccountName
    effectiveDate
    expirationDate
    reasonCode
    notes
    createdBy {
      email
      fullName
    }
    pricingBundle {
      ...PricingBundleFields
    }
  }
`;

export const LIST_ALL_ACTIVE_PRICING_ASSIGNMENTS = gql`
  query ListAllActivePricingAssignments(
    $input: ListAllActivePricingAssignmentsInput!
  ) {
    listAllActivePricingAssignments(input: $input) {
      totalCount
      tenants {
        id
        tenantId
        tenantName
        tenantSlug
        pricingBundleId
        pricingBundleName
        subaccountAssignments {
          id
          subaccountId
          subaccountName
          subaccountSlug
          pricingBundleId
          pricingBundleName
          isWeText
        }
      }
    }
  }
`;

export const GET_ACTIVE_PRICING_BUNDLES = gql`
  ${PRICING_BUNDLE_FIELDS}
  query GetActivePricingBundles {
    getActivePricingBundles {
      ...PricingBundleFields
    }
  }
`;

export const GET_ACTIVE_SKUS = gql`
  query GetActiveSkus {
    getActiveSkus {
      id
      name
      description
      rackPriceInMillicents
    }
  }
`;

export const GET_PRICING_BUNDLE_ARCHIVE_IMPACT = gql`
  query GetPricingBundleArchiveImpact(
    $input: GetPricingBundleArchiveImpactInput!
  ) {
    getPricingBundleArchiveImpact(input: $input) {
      activeTenantAssignments {
        id
        tenantId
        tenantName
        tenantSlug
        effectiveDate
        expirationDate
      }
      activeSubaccountAssignments {
        id
        tenantId
        tenantName
        subaccountId
        subaccountName
        effectiveDate
        expirationDate
      }
      scheduledTenantAssignments {
        id
        tenantId
        tenantName
        tenantSlug
        effectiveDate
        expirationDate
      }
      scheduledSubaccountAssignments {
        id
        tenantId
        tenantName
        subaccountId
        subaccountName
        effectiveDate
        expirationDate
      }
    }
  }
`;

export const ARCHIVE_PRICING_BUNDLE = gql`
  mutation ArchivePricingBundle($input: ArchivePricingBundleInput!) {
    archivePricingBundle(input: $input)
  }
`;

export const CHANGE_TENANT_PRICING_ASSIGNMENT = gql`
  mutation ChangeTenantPricingAssignment(
    $input: ChangeTenantPricingAssignmentInput!
  ) {
    changeTenantPricingAssignment(input: $input) {
      successCount
      failures {
        tenantId
        errorMessage
      }
    }
  }
`;

export const CREATE_SUBACCOUNT_PRICING_ASSIGNMENTS = gql`
  mutation CreateSubaccountPricingAssignments(
    $input: CreateSubaccountPricingAssignmentsInput!
  ) {
    createSubaccountPricingAssignments(input: $input)
  }
`;

export const CREATE_NEW_PRICING_BUNDLE = gql`
  mutation CreateNewPricingBundle($input: CreateNewPricingBundleInput!) {
    createNewPricingBundle(input: $input) {
      id
      name
      type
      isWeText
      prices {
        id
        skuId
        priceInMillicents
        sku {
          id
          name
        }
      }
    }
  }
`;

export const GET_TENANT_PRICING = gql`
  ${TENANT_ASSIGNMENT_FIELDS}
  ${SUBACCOUNT_ASSIGNMENT_FIELDS}
  query GetTenantPricing {
    getTenantPricing {
      currentAssignment {
        ...TenantAssignmentFields
      }
      futureAssignments {
        ...TenantAssignmentFields
      }
      pastAssignments {
        ...TenantAssignmentFields
      }
      currentSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
      futureSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
      pastSubaccountAssignments {
        ...SubaccountAssignmentFields
      }
    }
  }
`;
